import React from "react";
import about_imge from "../../assets/papers-about.png";
// import about_card from "../../assets/about_card.png";
import styles from "./PremiumPapers.module.css";
import image1 from "../../assets/benefit1.png";
import image2 from "../../assets/benefit2.png";
import image3 from "../../assets/benefit3.png";
import image4 from "../../assets/benefit4.png";
import image5 from "../../assets/Promo.png";

function About({ scrollToSection }) {
  // const benefits = [
  //   {
  //     name: "Our guarantee to you is that, we'll pay off any fines if we ever fail you.",
  //   },
  //   {
  //     name: "We help you keep an eye on the traffic fine portal to help avoid your vehicle from being impounded.",
  //   },
  //   {
  //     name: "We Keep an eye on all of your papers; Vehicle license, Roadworthiness and Insurance",
  //   },
  //   {
  //     name: "We send timely update and reminders. We then process the renewal and deliver.",
  //   },
  // ];

  const offerBenefits = [
    {
      name: "We Pay Fines",
      img: image1,
      about:
        "Our guarantee to you is that, we'll pay off any fines if we ever fail you.",
    },
    {
      name: "Car Papers",
      img: image2,
      about:
        "We monitor all of your vehicle papers monthly; Vehicle license, Roadworthiness, Insurance",
    },
    {
      name: "Updates and Reminder",
      img: image3,
      about:
        "We send timely updates and reminders. We then process the renewal and deliver it to you in the comfort of your home or office.",
    },
    {
      name: "Fine Portals",
      img: image4,
      about:
        "We monitor all traffic fine portals to help avoid your vehicle from being impounded.",
    },
    {
      name: "Get 100% Discount Now",
      img: image5,
      about:
        "Get 100% off when you subscribe now. This service is valued at ₦5,000 only, and you get access to all the benefits for 1 Year.",
    },
  ];

  return (
    <div className={styles.about}>
      <div className={styles.about_inner}>
        <div className={styles.about_inner_text}>
          <h1>About Premium Papers</h1>
          <div className={styles.about_image}>
            <div className={styles.about_image_wrapper}>
              <img src={about_imge} alt="about" />
            </div>
          </div>
          <p>
            Premium Papers is designed to help a million vehicle owners in Lagos
            state avoid traffic fines of between ₦20,000 and ₦60,000 per year
            per vehicle. We do this by leveraging technology to monitor all your
            expiry dates and traffic fine portals. If we ever fail, we'll pay
            your fine out of our pocket. We'll give you a contract to back this
            up.
          </p>
        </div>
      </div>

      {/* <div className={styles.about_inner}>
        <h1>Customer</h1>
        <div className={styles.about_card}>
          <div className={styles.about_card_inner}>
            <div className={styles.about_card_inner_upper}>
              <h2>
                We help you to avoid traffic fine of up to #60,000 yearly. (If
                we ever fail you, we would pay!)
              </h2>
              <p>
                You no longer need to go home or go to the bank to do this. Only
                through this platform, all financial activities can be
                completed.
              </p>
            </div>
            <div className={styles.about_card_inner_lower}>
              {benefits.map((data, index) => (
                <div key={index} className={styles.about_card_inner_lower_list}>
                  <div>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12L11 14L15 10"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div>
                    <p>{data.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.about_image2}>
            <div className={styles.about_image_wrapper2}>
              <img src={about_card} alt="about" />
            </div>
          </div>
        </div>
      </div> */}
      <div className={styles.benefits}>
        <h2>Benefits</h2>
        <div className={styles.benefits_card}>
          {offerBenefits.map((data, index) => (
            <div
              key={index}
              className={
                index % 2 === 0
                  ? styles.benefits_card_list
                  : styles.benefits_card_list2
              }
            >
              <div className={styles.image_wrapper}>
                <div className={styles.image_wrapper_inner}>
                  <img src={data.img} alt={data.name} />
                </div>
              </div>

              <div className={styles.details}>
                <h1>{data.name}</h1>
                <p>{data.about}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.benefits_sub}>
          <h1>To enjoy more benefits</h1>
          <svg
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8662 12.7971C12.4317 12.8631 12.9038 12.5088 12.9372 12.0299C12.9706 11.587 12.8918 10.9881 12.3327 10.66C12.2624 10.6183 12.1904 10.5798 12.1167 10.5445L12.0128 10.4909C11.5317 10.2569 10.2556 9.70113 9.0162 9.70113C8.73881 9.6987 8.46223 9.73147 8.19308 9.79863L7.97445 9.02163C8.01195 9.01113 8.88383 8.75163 10.0925 8.75163C10.4881 8.75163 10.8728 8.78163 11.2456 8.83638C12.5266 7.97238 13.1975 6.78438 13.0808 5.52063C13.0738 5.44792 13.0822 5.37455 13.1055 5.30532C13.1288 5.2361 13.1666 5.1726 13.2162 5.11901C13.3302 4.99301 13.508 4.92138 13.7022 4.92138C14.054 4.92138 14.3273 5.14338 14.3502 5.44901C14.4822 6.85413 13.8803 8.25925 12.6957 9.30101L12.7823 9.28938C13.1247 9.43075 13.4228 9.59913 13.7108 9.80875C13.871 9.28863 14.1871 8.73363 14.8752 8.45238C15.5431 8.16963 16.2413 8.32488 16.7776 8.662C17.0618 7.74625 17.7275 7.17963 18.5881 7.17963C18.6113 7.17963 18.6361 7.18188 18.6612 7.18375C19.0595 7.19913 19.472 7.33226 19.8875 7.58426C19.5552 6.26276 19.1708 5.25251 18.6548 4.33413C17.3431 1.99263 15.5592 1.14588 12.911 1.57976C12.8352 1.59288 12.7572 1.60001 12.6773 1.60001C12.4748 1.60001 12.3035 1.55763 12.1662 1.47551C10.9073 0.721755 9.68258 0.862755 8.50995 1.89063C6.45383 3.68426 5.36258 5.98413 5.26733 8.72538C5.2122 10.3386 6.09383 11.4554 7.7502 11.8698C8.0337 11.9421 8.31833 12.007 8.60033 12.0786C9.26745 12.2436 9.93308 12.4116 10.6036 12.568C10.9748 12.6543 11.4158 12.7491 11.8662 12.7971ZM10.427 17.9838C10.3051 16.6671 10.1791 15.3288 10.0636 13.7691C10.0662 13.723 10.0385 13.705 9.93345 13.6825C9.33533 13.546 8.90708 13.4061 8.29658 13.2633L7.45245 13.0728C7.45245 13.0728 7.4937 14.3759 7.49933 14.8885C7.5132 16.9431 7.44833 18.4848 7.46783 20.2259L7.45245 22.6908C7.46033 23.3766 7.66545 23.9628 8.10345 24.4338C8.44658 24.7998 8.86958 25.003 9.31283 25.0041C9.85245 25.0026 10.3182 24.6903 10.5597 24.1679C10.5695 24.1461 10.5758 24.1233 10.5863 24.1004C10.7645 23.6958 10.8571 23.2619 10.8342 22.891C10.7123 21.0588 10.5732 19.5659 10.427 17.9823"
              fill="#EFB086"
            />
            <path
              d="M18.3049 14.0568C18.0312 12.5493 17.4345 11.191 16.533 10.0259C16.473 9.94714 16.3909 9.87477 16.2964 9.79152C15.9664 9.51027 15.6912 9.43302 15.3799 9.54927C15.0818 9.65652 14.8853 9.85489 14.7687 10.5359C14.7728 10.6041 14.7754 10.684 14.7769 10.7733C14.7818 11.0331 14.7889 11.3568 14.8557 11.6575C14.9832 12.2395 15.1384 12.8133 15.2944 13.3866C15.405 13.7999 15.5172 14.2139 15.6177 14.6286C15.7707 15.2526 16.2769 15.6723 16.875 15.6723C17.1195 15.6723 17.3562 15.6021 17.5797 15.4664C17.9835 15.2208 18.4362 14.7753 18.3049 14.0568ZM21.3237 12.2088C21.3049 12.0966 21.2903 11.9826 21.2757 11.8698C21.243 11.5945 21.2115 11.335 21.111 11.1554C20.664 10.3679 20.1342 9.62427 19.584 8.86827C19.4888 8.74002 19.3047 8.60839 19.038 8.47902C18.5202 8.22627 17.9847 8.50752 17.9389 9.04864C17.9033 9.45739 18.0503 9.92727 18.1617 10.2449C18.3113 10.6653 18.4999 11.068 18.6998 11.4948C18.7875 11.6849 18.879 11.8735 18.9634 12.0636C19.0028 12.1514 19.0395 12.2433 19.0748 12.3344C19.1438 12.5058 19.2075 12.6685 19.293 12.8016C19.5075 13.1388 19.9467 13.312 20.352 13.2273C20.7777 13.1328 21.1362 12.7551 21.3237 12.2088ZM14.4424 15.0025C14.3382 14.2525 14.1878 13.5273 13.9962 12.8523C13.9883 12.8181 13.9774 12.7855 13.968 12.7514C13.9043 12.9156 13.8207 13.0641 13.7183 13.1999C13.2777 13.78 12.5303 14.0586 11.4777 13.9986C11.4867 14.0744 11.4957 14.149 11.5035 14.224C11.5635 14.7359 11.6198 15.2204 11.7229 15.7C11.8459 16.2906 12.1879 16.6476 12.7362 16.7639C12.8468 16.7871 12.9559 16.7988 13.0613 16.7988C13.2558 16.8006 13.4483 16.76 13.6254 16.6797C13.8026 16.5995 13.9601 16.4815 14.0869 16.3341C14.3869 15.9891 14.5129 15.5151 14.4424 15.0025Z"
              fill="#EFB086"
            />
          </svg>
          <p onClick={() => scrollToSection("#signup")}>Sign up now</p>
        </div>
      </div>
    </div>
  );
}

export default About;
